
import OutboundDealsPerPageFilterField from './outbound-deals-per-page-filter-field'
import OutboundDealsSortFilterField from './outbound-deals-sort-filter-field'
import PropTypes from 'prop-types'
import { ListGroup, ListGroupItem } from 'reactstrap'

const propTypes = {
  perPage               : PropTypes.string,
  sortBy                : PropTypes.string,
  sortDir               : PropTypes.string,
  handlePerPageOnChange : PropTypes.func,
  handleSortOnClick     : PropTypes.func
}

const defaultProps = {
  perPage               : '10',
  sortBy                : '',
  sortDir               : '',
  handlePerPageOnChange : () => { },
  handleSortOnClick     : () => {}
}

const OutboundDealsPagingFilterField = ({
  perPage,
  sortBy,
  sortDir,
  handlePerPageOnChange,
  handleSortOnClick
}) => (
  <ListGroup className='pb-2'>
    <ListGroupItem>
      <OutboundDealsPerPageFilterField
        perPage={ perPage }
        handlePerPageOnChange={ handlePerPageOnChange }
      />
    </ListGroupItem>

    <ListGroupItem>
      <OutboundDealsSortFilterField
        sortBy={ sortBy }
        sortDir={ sortDir }
        handleSortOnClick={ handleSortOnClick }
      />
    </ListGroupItem>
  </ListGroup>
)

OutboundDealsPagingFilterField.propTypes    = propTypes
OutboundDealsPagingFilterField.defaultProps = defaultProps

export default OutboundDealsPagingFilterField
